import _extends from 'babel-runtime/helpers/extends';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
/* babel-plugin-inline-import '../assets/images/arrow-up-solid-grey.svg' */var arrowUp = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBmaWxsPSIjNjY2Ij4KICAgIDxwYXRoIGQ9Ik0gNSAyMTAKICAgICAgICAgICAgbCAxNDUgLTE1OAogICAgICAgICAgICBsIDE0NSAxNTgKICAgICAgICAgICAgeiIKICAgIC8+Cjwvc3ZnPgo=';
/* babel-plugin-inline-import '../assets/images/arrow-up-light-grey.svg' */var lightArrowUp = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89Im5vbmUiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBmaWxsPSIjQ0NDIj4KICAgIDxwYXRoIGQ9Ik0gNSAyMTAKICAgICAgICAgICAgbCAxNDUgLTE1OAogICAgICAgICAgICBsIDE0NSAxNTgKICAgICAgICAgICAgeiIKICAgIC8+Cjwvc3ZnPgo=';

import { menuStyle as StandardDropdownStyle } from './StandardDropdownStyle';

var zoomUpOpen = keyframes({
  '0%': {
    opacity: 0,
    transformOrigin: 'bottom left',
    transform: 'scaleY(0)'
  },
  '100%': {
    opacity: 1,
    transformOrigin: 'bottom left',
    transform: 'scaleY(1)'
  }
});

export var dropupStyle = _extends({}, StandardDropdownStyle, {

  MenuList: styled(StandardDropdownStyle.MenuList)(function (props) {
    var style = {
      boxShadow: '0 0px 12px rgba(0,0,0,.175)'
    };
    if (props.animationToDo === 'showing') {
      style.animation = zoomUpOpen + ' 300ms linear';
    }
    if (props.animationToDo === 'hiding') {
      style.animation = zoomUpOpen + ' 300ms linear reverse';
    }
    return style;
  }),

  MenuButtonArrow: styled(StandardDropdownStyle.MenuButtonArrow)(function (props) {
    var style = {
      backgroundImage: 'url(' + arrowUp + ')'
    };
    if (props.menuDisabled) {
      style.backgroundImage = 'url(' + lightArrowUp + ')';
    }
    return style;
  })
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rosetta/rs-dropdown/es/styles/StandardDropupStyle.js
// module id = 678
// module chunks = 0